import { Component, OnInit ,Input,ViewChild,ElementRef} from '@angular/core';
import { GfichierService } from '../../service/gfichier.service';

@Component({
  selector: 'app-htmlcssprint',
  templateUrl: './htmlcssprint.component.html',
  styleUrls: ['./htmlcssprint.component.scss'],
})
export class HtmlcssprintComponent implements OnInit {

  @Input() code: string;
  @Input() id: number;
  @Input() posi: number;

  codecss: string;
  codejs: string;
  monimage : any;

  @ViewChild('idhtml', { static: true }) idhtml: ElementRef;
  @ViewChild('idcss', { static: true }) idcss: ElementRef;
  @ViewChild('idjs', { static: true }) idjs: ElementRef;
  //@ViewChild('idback', { static: true }) idback: ElementRef;

  visicss: boolean = true;
  visijs: boolean = true;
  selection = "0";
 
  constructor(public gfichier: GfichierService) { }

  ngOnInit() {

  this.idhtml.nativeElement.innerText = this.code;
  let valeur = this.gfichier.getValue(this.posi,this.id, "css");
  //alert(valeur);
  if (valeur == undefined) {
    this.visicss = false;
    //document.getElementById("css1").style.display = "none";

  }
  else {
    //document.getElementById("css1").style.display = "block";
    this.visicss = true;
    this.codecss = valeur;
    this.idcss.nativeElement.innerText = valeur;
  }

  valeur = this.gfichier.getValue(this.posi,this.id, "js");
  if (valeur == undefined) {
    this.visijs = false;
    //document.getElementById("js1").style.display = "none";

  }
  else {

    //document.getElementById("js1").style.display = "block";
    this.visijs = true;
    this.codejs = valeur;
    this.idjs.nativeElement.innerText = valeur;
  }

  valeur = this.gfichier.getValue(this.posi,this.id, "selection");
  if (valeur == undefined) {
    this.selection = "2";
  }
  else {
    this.selection = String(valeur);
  }
  
  this.monimage = this.gfichier.getValue(this.posi,this.id,"output");

 

  //this.selectionChange();

}

selectionChange() {

  /*


if (this.selection == "0") {
  this.idback.nativeElement.style.width = "240px";
  this.idback.nativeElement.style.height = "400px";
//   this.idback.nativeElement.style.padding = "15px";
} else if (this.selection == "3") {
  this.idback.nativeElement.style.width = "130px";
  this.idback.nativeElement.style.height = "130px";
//   this.idback.nativeElement.style.padding = "10px";
} else if (this.selection == "1") {
  this.idback.nativeElement.style.width = "340px";
  this.idback.nativeElement.style.height = "500px";
//   this.idback.nativeElement.style.padding = "15px";
} else if (this.selection == "2") {
  this.idback.nativeElement.style.width = "100%";
  setTimeout(() => {
    this.idback.nativeElement.style.height = this.idback.nativeElement.style.width*3/4;
//     this.idback.nativeElement.style.padding = "15px";

  },600); }
  
  */
  
  //this.compiler();

}//selection

}
